import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import IconButton from "@mui/material/IconButton";
import makeStyles from "@mui/styles/makeStyles";
import { Collapse, Grid, InputBase, Paper } from "@mui/material";
import { AddRounded, RemoveRounded, SearchRounded } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  backButtonWrapper: {
    display: "flex",
    justifyContent: "space-between",
    padding: "7px",
  },
  citiisLogo: {
    height: 20,
  },
  leftButtonWrapper: {
    backgroundColor: "#46bacf",
    "&:focus": {
      backgroundColor: "#46bacf",
    },
  },
  input: {
    border: "2px solid rgba(0,0,0, 0.3)",
    borderRadius: "10px",
    width: "100%",
    height: "100%",
    padding: "5px",
    fontSize: "18px",
  },
  iconPosition: {
    position: "absolute",
    right: 10,
    top: "50%",
    transform: "translateY(-50%)",
    color: "rgba(0,0,0,0.9)",
    height: "40px",
    width: "40px",
    [theme.breakpoints.down("sm")]: {
      height: 30,
      width: 30,
    },
  },
  logo: {
    height: 60,
    [theme.breakpoints.down("md")]: {
      height: 32,
    },
  },
}));

export default function TemporaryDrawer(props) {
  const { open, setOpen, menu, shareItems, logos } = props;
  const classes = useStyles();
  const navigate = useNavigate();

  const [collapse, setCollapse] = React.useState(-1);
const [childCollapse, setChildCollapse] = React.useState({});
  const list = () => (
    <Box sx={{ width: "calc(100vw - 40px)" }} role="presentation">
      <List>
        {menu.map((item, index) => (
          <>
            <ListItem key={index} disablePadding>
              <ListItemButton
                onClick={() => {
                  if (item.submenu) {
                    setCollapse((prev) => (prev === index ? -1 : index));
                  } else if (item.url) {
                    navigate(item.url)
                    setCollapse(-1)
                    setOpen(false)
                  }
                }}
              >
                <ListItemText
                  primary={
                    <Typography
                      sx={{ textTransform: "capitalize", display: "flex" }}
                      variant="thicksmall"
                    >
                      <span style={{ flex: 1 }}>{item.name}</span>
                      {item.submenu &&
                        (collapse === index ? (
                          <RemoveRounded />
                        ) : (
                          <AddRounded />
                        ))}
                    </Typography>
                  }
                />
              </ListItemButton>
            </ListItem>
            {item.submenu && (
              <Collapse in={collapse === index} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                {item.submenu.map((subitem, childIndex) => (
  <React.Fragment key={subitem.name}>
    <ListItemButton
      sx={{ pl: 4 }}
      onClick={() => {
        if (subitem.submenu) {
          setChildCollapse((prev) => ({
            ...prev,
            [subitem.name]: !prev[subitem.name],
          }));
        } else if (subitem.url) {
          setOpen(false);
          navigate(subitem.url);
        }
      }}
    >
      <ListItemText
        primary={
          <Typography
            sx={{ textTransform: "capitalize" }}
            variant="thicksmall"
          >
            {subitem.name}
          </Typography>
        }
      />

      {subitem.submenu &&
        (childCollapse[subitem.name] ? (
          <RemoveRounded />
        ) : (
          <AddRounded />
        ))}
    </ListItemButton>

    {subitem.submenu && (
      <Collapse
        in={childCollapse[subitem.name]}
        timeout="auto"
        unmountOnExit
      >
        <List component="div" disablePadding>
          {subitem.submenu.map((nestedItem) => (
            <ListItemButton
              key={nestedItem.name}
              sx={{ pl: 8 }}
              onClick={() => {
                setOpen(false);
                navigate(nestedItem.url);
              }}
            >
              <ListItemText
                primary={
                  <Typography
                    variant="body2"
                    sx={{ textTransform: "capitalize" }}
                  >
                    {nestedItem.name}
                  </Typography>
                }
              />
            </ListItemButton>
          ))}
        </List>
      </Collapse>
    )}
  </React.Fragment>
))}
                </List>
              </Collapse>
            )}
            <Divider />
          </>
        ))}
      </List>
    </Box>
  );

  return (
    <Drawer anchor={"right"} open={open} onClose={() => setOpen(false)}>
      <Paper elevation={3} className={classes.backButtonWrapper}>
        <IconButton
          onClick={() => setOpen(false)}
          className={classes.leftButtonWrapper}
        >
          <ArrowForwardRoundedIcon
            sx={{ height: 25, width: 25, color: "white" }}
          />
        </IconButton>
        <Box sx={{ position: "relative", paddingLeft: "10px" }}>
          <InputBase className={classes.input} />
          <SearchRounded className={classes.iconPosition} />
        </Box>
        <IconButton disableFocusRipple disableRipple disableTouchRipple>
          <img
            src={require("../../assets/citiis.png")}
            alt={"citiis"}
            className={classes.citiisLogo}
          />
        </IconButton>
      </Paper>
      <Box sx={{ overflowY: 'scroll' }}>
        {list()}</Box>
      <Box
        sx={{ position: "absolute", bottom: 0, width: "100%", padding: "10px", backgroundColor: 'white' }}
      >
        <Box>
          <Typography
            variant="thinsmall"
            sx={{ padding: "10px", color: "rgba(0,0,0,0.5)" }}
          >
            In Association with
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              paddingBottom: "15px",
            }}
          >
            <Grid container>
              {logos.map((logo, index) => {
                return (
                  <Grid
                    item
                    xs={3}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <IconButton
                      key={index}
                      disableFocusRipple
                      disableRipple
                      disableTouchRipple
                    >
                      <img
                        src={logo.icon}
                        alt={index}
                        className={classes.logo}
                      />
                    </IconButton>
                  </Grid>
                );
              })}
            </Grid>
          </Box>
        </Box>
        <Box sx={{ display: 'flex' }}>{shareItems}</Box>
      </Box>
    </Drawer>
  );
}
